import Translations from "translations/types";

const CAREPROVIDER_DASHBOARD_PAGE_KEY = "careprovider_dashboard" as const;

const CAREPROVIDER_DASHBOARD_STEPS = {
  BLOCK_CAPACITIES: "capacity_setup_link",
  BULK_DECLINE: "bulk_decline_checkbox",
  OTHER_TAB: "other_tab",
  REVERSE_SEARCH_NAVBAR: "reverse_search_navbar",
} as const;

export const CAREPROVIDER_DASHBOARD_PAGE = {
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  key: CAREPROVIDER_DASHBOARD_PAGE_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  scrollToElement: false,
  steps: {
    [CAREPROVIDER_DASHBOARD_STEPS.BLOCK_CAPACITIES]: {
      intro: (t: Translations) => t.tours.receiverDashboard.stepD.intro,
      key: CAREPROVIDER_DASHBOARD_STEPS.BLOCK_CAPACITIES,
      step: 4,
      title: (t: Translations) => t.tours.receiverDashboard.stepD.title,
    },
    [CAREPROVIDER_DASHBOARD_STEPS.BULK_DECLINE]: {
      intro: (t: Translations) => t.tours.receiverDashboard.stepB.intro,
      key: CAREPROVIDER_DASHBOARD_STEPS.BULK_DECLINE,
      step: 1,
      title: (t: Translations) => t.tours.receiverDashboard.stepB.title,
    },
    [CAREPROVIDER_DASHBOARD_STEPS.OTHER_TAB]: {
      intro: (t: Translations) => t.tours.receiverDashboard.stepC.intro,
      key: CAREPROVIDER_DASHBOARD_STEPS.OTHER_TAB,
      step: 2,
      title: (t: Translations) => t.tours.receiverDashboard.stepC.title,
    },
    [CAREPROVIDER_DASHBOARD_STEPS.REVERSE_SEARCH_NAVBAR]: {
      intro: (t: Translations) => t.tours.receiverDashboard.stepThree.intro,
      key: CAREPROVIDER_DASHBOARD_STEPS.REVERSE_SEARCH_NAVBAR,
      step: 3,
      title: (t: Translations) => t.tours.receiverDashboard.stepThree.title,
    },
  },
} as const;
